// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4f57f00f","677":"9075de6f"}[chunkId] + ".chunk.js";
};